import React from 'react';

/* eslint-disable max-len */
export default () => (
    <svg version="1.1" id="up-logo-wrapper" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 216.8 77" enableBackground="new 0 0 216.8 77" xmlSpace="preserve">
        <path
            className="logo-letter"
            d="M43.5,23.5c-0.6,0-1.4,0.2-1.9,0.6c-0.5,0.4-0.8,2.1-0.8,2.7l-0.9,16.5c-0.5,9.8-4.5,13.7-14.4,13.7
                c-3.2,0-6.5-0.5-9.1-2.5c-3.3-2.7-3.3-6.9-3.1-11l0.9-16.6c0.1-2.2-0.1-3.4-2.6-3.4l0.5-2.7h11.1l-0.3,2.6c-2.2,0-2.9,1.1-3,3.1
                l-0.9,17.8c-0.3,6.3,1.2,8.5,7.6,8.5c6.5,0,7.7-3.5,8-9.3l0.9-17.4c0.1-2-0.6-2.6-2.5-2.8l0.5-2.7H44L43.5,23.5z"
        />

        <path
            className="logo-letter responsive-letter"
            d="M65.7,40.5c-2.8,1.1-9.6,1-12.8,1L52.4,51c-0.1,2,0.7,2.5,2.6,2.7l-0.3,2.6h-11l0.4-2.6
                c0.1,0,0.2,0.1,0.3,0.1c2,0,2.5-1.7,2.6-3.4l1.2-23.7c0.1-2,0-3.2-2.4-3.2l0.5-2.7c1.8,0.1,3.6,0.2,5.4,0.2c3.4,0,6.7-0.3,10.1-0.3
                c1.5,0,3.1,0.1,4.5,0.6c3.9,1.5,5.6,5.3,5.4,9.4C71.4,34.6,69.7,39,65.7,40.5z M60.1,24.8h-3.8c-2.2,0-2.6,1.4-2.7,3.2l-0.5,9.2
                c1.2,0.1,2.4,0.1,3.6,0.1h1.5c4.7,0,7.2-1.3,7.5-6.4C65.9,26.7,64.3,24.8,60.1,24.8z"
        />

        <path
            className="logo-letter responsive-letter"
            d="M83.4,56.8c-3.8,0-7.5-0.8-11.4-0.8c0.2-1.3,0.4-8.8,0.4-8.8l3.5,0.1c0.1,4.6,3.2,5.4,7.2,5.4
                c3.8,0,7.2-1.3,7.4-5.7c0-0.9-0.1-1.7-0.4-2.5C87.7,39,73,41.3,73.5,30.4c0.3-6.6,5.2-10.1,11.5-10.1c3.8,0,7.4,1,11.2,1.1
                c-0.1,1-0.2,1.9-0.3,2.9c-0.1,1.5-0.1,3,0,4.6l-3.5,0.1c0-3.7-3.9-4.4-6.9-4.4c-3,0-6.2,1.7-6.3,5.1c-0.5,8.9,17.4,2.6,16.7,16.4
                C95.5,53.5,90.5,56.8,83.4,56.8z"
        />

        <path
            className="logo-letter responsive-letter"
            d="M153.9,53.6l-0.4,2.7h24.1l1.1-9.1l-3.3,0.1c-0.2,3.8-1.8,5.1-4.9,5.1h-6.1c-1.7,0-3.1-0.4-3-2.3l0.5-10.2
                h11.9l0.5-4.3h-12.2l0.4-7.8c0.1-2.1,0.5-2.8,2.7-2.8h7.1c0.9,0,1.6,0.1,2.1,0.7c0.5,0.7,0.7,1.5,0.7,2.4h3.3
                c-0.2-2.4-0.2-4.9-0.3-7.4h-23.2l-0.3,2.9c2.1,0.2,2.5,0.7,2.4,2.8L156,50.4C155.8,52.4,155.8,53.3,153.9,53.6z"
        />

        <path
            className="logo-letter responsive-letter"
            d="M188.5,29.6c0.2-3.4,3.3-5.1,6.3-5.1c2.9,0,6.9,0.7,6.9,4.4l3.5-0.1c-0.1-1.5-0.1-3,0-4.6
                c0-1,0.2-1.9,0.3-2.9c-3.8-0.1-7.4-1.1-11.2-1.1c-6.3,0-11.2,3.6-11.5,10.1c-0.6,11,14.1,8.6,16.5,14.1c0.3,0.8,0.4,1.6,0.4,2.5
                c-0.2,4.4-3.5,5.7-7.4,5.7c-4,0-7.1-0.9-7.2-5.4l-3.3-0.1l-1.1,9.1c3.8,0,8.2,0.5,12,0.5c7.1,0,12.2-3.3,12.5-10.8
                C205.9,32.2,188,38.5,188.5,29.6z"
        />

        <path
            className="logo-letter responsive-letter"
            d="M119.2,53.7l-0.3,2.6h8.8l0.4-2.6c-0.3,0-0.5-0.1-0.7-0.2c-0.4-0.3-1-1.4-1.1-1.9L117.4,24
                c-0.3-1-0.6-2.1-0.7-3.2H111c-0.1,1.3-0.5,2.3-1,3.5L97.4,51.4c-0.5,1.2-1,2-2.3,2.3l-0.2,2.6h8.7l0.4-2.7c-0.9-0.1-1.6-0.4-1.5-1.4
                c0-0.4,0.2-0.7,0.3-1.1l3.1-6.4h12.4l2.1,6.6c0.1,0.4,0.3,0.7,0.3,1.2C120.5,53.4,119.9,53.6,119.2,53.7z M107.3,40.8l5.1-11.2
                c0.5-1.1,0.8-2.1,0.9-3.2c0.1,1,0.2,2,0.5,3l3.4,11.4H107.3z"
        />

        <path
            className="logo-letter responsive-letter"
            d="M149.5,48c-0.3,3.9-2.7,4.3-6,4.3c-1.3,0-2,0-3.3-0.1c-1.3-0.1-2.6-0.1-2.8-1.5c-0.1-0.6-0.1-1.1-0.1-1.7
                l1.2-23.5c0.1-1.8,1.4-2.1,2.9-2.1l0.3-2.7h-10.9l-0.4,2.7c1.9,0,2.7,0.6,2.6,2.6l-1.3,24.2c-0.1,2.1-0.4,3-2.2,3.3l-0.4,2.7h22.6
                c0.4-2.8,0.7-5.6,1.2-8.4L149.5,48z"
        />
    </svg>
);




/** WEBPACK FOOTER **
 ** ./client/assets/UpsalesLogo.jsx
 **/